export const LiveBadge = ({ href }) => {
  if (href) {
    return (
      <a href={href} className="live-badge">
        <div className="streaming-now-dot"></div>
        Live
      </a>
    );
  }

  return (
    <span className="live-badge">
      <div className="streaming-now-dot"></div>
      Live
    </span>
  );
};
